import React from "react";

const ShippingPolicy = () => {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "30px 20px",
        lineHeight: "1.7",
        color: "#333",
        textAlign: "left",
      }}
    >
      <h1
        style={{
          marginBottom: "20px",
          fontSize: "2rem",
          fontWeight: "600",
          color: "#222",
          textAlign: "left",
        }}
      >
        Shipping & Delivery Policy – Speak Bold with KK
      </h1>

      <p>
        Speak Bold with KK provides <strong>digital-only</strong> products and
        services. No physical goods are shipped.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        Digital Delivery
      </h2>
      <ul style={{ paddingLeft: "20px" }}>
        <li>
          After successful payment, users receive <strong>instant access</strong>{" "}
          to premium digital content.
        </li>
        <li>
          Session details and confirmations are delivered via email or in-app
          notifications.
        </li>
      </ul>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        Delivery Time
      </h2>
      <p>
        Access to digital services is typically provided immediately after the
        payment is completed.
      </p>

      <h2
        style={{
          marginTop: "30px",
          fontSize: "1.4rem",
          fontWeight: "500",
          textAlign: "left",
        }}
      >
        Support
      </h2>
      <p>
        For delivery-related concerns, you can reach us at:
      </p>
      <p>
        <strong>Email:</strong> support@speakboldwithkk.com
      </p>
    </div>
  );
};

export default ShippingPolicy;
